import { Autocomplete, CircularProgress, createFilterOptions, debounce, TextField } from '@mui/material';
import { apiRequest } from "api-client";
import { unionBy } from "lodash";
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from "react";

const localFilterOptions = createFilterOptions();


export const RemoteSourceAutoComplete = ({
  apiPath,
  searchKey = 'searchStr',
  localFilter = false, // by default, it should be remote filter. In some cases, API request returns all data, so localFilter is enough.
  getOptionLabel,
  placeholder,
  onChange,
  queryParams = {},
  selectedId,
  disabled,
  staticList = [],
}) => {
  const [searchStr, setSearchStr] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(null);

  const onSearch = debounce((str) => {
    if (!localFilter) {
      setSearchStr(str);
    }
  }, 300);

  const onChangeValue = (e, value) => {
    setValue(value);
    onChange(value);
  }

  useEffect(() => {
    setLoading(true);
    if (disabled && selectedId) {
      loadSelectedItem();
      return;
    }
    apiRequest.get(`/${apiPath}`, {
      params: {[searchKey]: searchStr, ...queryParams},
    }).then(data => {
      setOptions(data);
      if (selectedId) {
        const selectedItem = data.find(item => item.id === selectedId);
        if (selectedItem) {
          setValue(selectedItem);
          setLoading(false);
        } else {
          loadSelectedItem();
        }
      } else {
        setLoading(false);
      }
    });
  }, [searchStr]);

  const loadSelectedItem = () => {
    apiRequest.get(`/${apiPath}/${selectedId}`).then((data) => {
      setOptions([...options, data]);
      setValue(data);
      setLoading(false);
    });
  }

  const unionOptions = useMemo(() => {
    return unionBy(staticList, options, 'id');
  }, [staticList, options])

  return (
    <Autocomplete
      fullWidth
      disabled={disabled}
      options={unionOptions}
      autoHighlight
      getOptionLabel={getOptionLabel}
      onChange={onChangeValue}
      filterOptions={localFilter ? localFilterOptions : (x) => x}
      value={value}
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          onChange={(e) => onSearch(e.target.value)}
          label={placeholder || 'Select One'}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} sx={{marginRight: 1}} /> : params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}

RemoteSourceAutoComplete.propTypes = {
  apiPath: PropTypes.string.isRequired,
  searchKey: PropTypes.string,
  getOptionLabel: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}